export default __webpack_public_path__ + "static/mwwc-logo-32efed3b9e9e283052561c88e5cf78de.svg";